module.exports = __webpack_public_path__ + "img/figur.159691be.svg";